import { SectionBasedProduct } from '../../types';

/**
 * Convert a raw tool-output product into the minimal shape that
 * ConciergeProductCard actually reads at runtime.  ProductGroupCarousel
 * force-casts via `as unknown as ProductRewardSearchResult`, so only
 * the fields the card accesses need to be present.
 */
export function toolProductToSectionProduct(p: any): SectionBasedProduct {
  const reward = p.totalRewardAmount ?? p.rewardAmount ?? 0;
  return {
    stacklineSku: p.stacklineSku,
    title: p.title || '',
    retailPrice: p.price ?? 0,
    retailerId: p.retailerId ?? 0,
    reviewsRating: p.rating ?? 0,
    reviewsAverageRating: p.rating ?? 0,
    reviewsCount: p.reviewCount ?? 0,
    hasRewards: !!p.hasRewards || reward > 0,
    totalRewardAmount: reward,
    affiliateRewardAmount: 0,
    hasActiveInstantReward: false,
    isAvailable: p.isAvailable ?? true,
    imageUrls: p.imageUrl ? [p.imageUrl] : [],
    brandName: p.brand || '',
    retailerProductPageUrl: p.retailerProductPageUrl || '',
  } as unknown as SectionBasedProduct;
}

export function toolOutputToFeaturedProduct(p: any): SectionBasedProduct {
  return {
    stacklineSku: p.stacklineSku || p.sku,
    title: p.title || '',
    retailPrice: p.retailPrice ?? p.price ?? 0,
    retailerId: p.retailerId ?? 0,
    reviewsRating: p.reviewsRating ?? p.rating ?? 0,
    reviewsAverageRating: p.reviewsAverageRating ?? p.reviewsRating ?? p.rating ?? 0,
    reviewsCount: p.reviewsCount ?? p.reviewCount ?? 0,
    hasRewards: !!p.hasRewards,
    totalRewardAmount: p.totalRewardAmount ?? 0,
    affiliateRewardAmount: 0,
    hasActiveInstantReward: false,
    isAvailable: p.isAvailable ?? true,
    imageUrls: p.imageUrls || (p.imageUrl ? [p.imageUrl] : []),
    brandName: p.brandName || p.brand || '',
    featureBullets: p.featureBullets || [],
    variants: p.variants || [],
    variationNameValues: p.variationNameValues || {},
    checkoutEligibility: p.checkoutEligibility,
    retailerDisplayName: p.retailerDisplayName || '',
    retailerProductPageUrl: p.retailerProductPageUrl || '',
    campaignRewards: p.campaignRewards || [],
  } as unknown as SectionBasedProduct;
}

export const SECTION_STAGGER_MS = 300;

export const sectionFadeInStyle = `
@keyframes concierge-fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}`;

export const GREY_PLACEHOLDER_SVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Crect width='120' height='120' fill='%23f5f5f5' rx='8'/%3E%3C/svg%3E";
